module.exports = __webpack_public_path__ + "648cd0dc1b95240103d1ccb33c575480.jpg";